import PublishStatusDot from '../../../misc/PublishStatusDot.js';
import DatePicker, {registerLocale} from 'react-datepicker';
import dpLocale from 'date-fns/locale/nb';
import update from 'immutability-helper';
import {NavLink as Link} from 'react-router-dom';
import React from 'react';
import EntityField from '../../../contentful/EntityField';
import {ArrayEditor, SchemaTypes} from 'object-editor-react';

import './WarrantyPeriod.scss';

import 'react-datepicker/dist/react-datepicker.css';
registerLocale('nb', dpLocale);

const schemaReg = {
  year: SchemaTypes.string(),
  standard: SchemaTypes.string(),
  rust: SchemaTypes.string()
};

const schemaBattery = {
  year: SchemaTypes.string(),
  battery: SchemaTypes.string()
};

class WarrantyPeriod extends React.Component {
  constructor(props) {
    super(props);
    this.handleAssetChange = this.handleAssetChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handlePublish = this.handlePublish.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);

    this.addRow = this.addRow.bind(this);
    this.removeRows = this.removeRows.bind(this);
    this.updateRow = this.updateRow.bind(this);
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.onSave();
  }

  handlePublish(e) {
    e.preventDefault();
    this.props.onPublish();
  }

  handleAssetChange(name, asset) {
    const event = {
      target: {
        name: name,
        value: asset
      }
    };

    this.handleFieldChange(event);
  }

  handleFieldChange(e) {
    const newData = {
      warrantyPeriod: {}
    };

    if (e.target.type === 'checkbox') {
      e.target.value = e.target.checked;
    }

    newData.warrantyPeriod[e.target.name] = {
      $set: e.target.value
    };

    const props = update(this.props, newData);

    this.props.onChange(props);
  }

  handleDateChange(inputName, date) {
    const event = {
      target: {
        name: inputName,
        value: date
      }
    };

    this.handleFieldChange(event);
  }

  // Functions for handling json data
  addRow(newObject, fieldName = 'jsonReg') {
    const object = this.props.warrantyPeriod[fieldName];
    object.push(newObject);

    const event = {
      target: {
        name: fieldName,
        value: object
      }
    };

    this.handleFieldChange(event);
    return true;
  }

  removeRows(removedIndices, fieldName = 'jsonReg') {
    if (removedIndices.length > 0) {
      const object = this.props.warrantyPeriod[fieldName];
      const newObject = object.filter((el, index) => {
        return !removedIndices.includes(index);
      });

      const event = {
        target: {
          name: fieldName,
          value: newObject
        }
      };

      this.handleFieldChange(event);
    }
  }

  updateRow(updated, idx, fieldName = 'jsonReg') {
    const object = this.props.warrantyPeriod[fieldName];
    if (object[idx]) {
      object[idx] = updated;

      const event = {
        target: {
          name: fieldName,
          value: object
        }
      };

      this.handleFieldChange(event);
    }
  }

  render() {
    if (this.props.warrantyPeriod) {
      const warrantyPeriod = this.props.warrantyPeriod;

      const isMMC = (this.props.makeName === 'mitsubishi');

      return (
        <section className="color mf-padding-top-20">
          <ol className="breadcrumb">
            <li><Link to="/">Forsiden</Link></li>
            <li><Link to={`/warrantyperiods/${this.props.makeName}`}>Garantiperioder</Link></li>
            <li className="active">{warrantyPeriod.title}</li>
          </ol>

          <form onSubmit={this.handleSubmit}>
            <div className="page-header">
              <div className="pull-right">
                {this.props.working &&
                    <span>&nbsp;<i className="fa fa-spinner fa-pulse fa-fw"></i> Arbeider...</span>
                }
                {!warrantyPeriod.archived &&
                  <button
                    type="submit"
                    className="btn btn-default"
                    disabled={!this.props.modified || this.props.working}
                  >
                    {Boolean(warrantyPeriod.id) &&
                        <span>Lagre</span>
                    }
                    {!warrantyPeriod.id &&
                        <span>Opprett ny periode</span>
                    }
                  </button>
                }
                &nbsp;
                {warrantyPeriod.id && <React.Fragment>
                  <button
                    type="button"
                    className="btn btn-success"
                    disabled={(warrantyPeriod.published && !warrantyPeriod.updated) || warrantyPeriod.archived || this.props.working || this.props.modified}
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.onPublish();
                    }}
                  >
                    <span>Publiser</span>
                  </button>
                 &nbsp;
                  <button
                    type="button"
                    className="btn btn-warning"
                    disabled={warrantyPeriod.draft || this.props.working || this.props.modified}
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.onUnpublish();
                      if (warrantyPeriod.archived) {
                        this.props.onUnarchive();
                      }
                    }}
                  >
                    <span>Kladd</span>
                  </button>
                  &nbsp;
                  {!warrantyPeriod.archived &&
                    <button
                      type="button"
                      className="btn btn-danger"
                      disabled={this.props.working}
                      onClick={(e) => {
                        e.preventDefault();
                        this.props.onArchive();
                      }}
                    >
                      <span>Arkiver</span>
                    </button>
                  }
                  &nbsp;
                  {warrantyPeriod.archived &&
                    <button
                      type="button"
                      className="btn btn-danger"
                      disabled={this.props.working}
                      onClick={(e) => {
                        e.preventDefault();
                        this.props.onUnarchive();
                      }}
                    >
                      <span>Gjenopprett</span>
                    </button>
                  }
                </React.Fragment>}
                <div className="text-right mf-padding-top-10">
                  <Link
                    className="btn btn-default"
                    to={`/warrantyperiods/${this.props.makeName}/`}
                  >
                    <i className="fa fa-arrow-left" aria-hidden="true"></i> Tilbake til garantiperioder
                  </Link>
                </div>
              </div>

              <h1>
                {warrantyPeriod.title} <PublishStatusDot entry={warrantyPeriod} /><br />
                <small>{warrantyPeriod.make.name}</small>
              </h1>
            </div>

            {/* Display any error message: */}
            {this.props.error &&
                <div className="alert alert-danger">
                  {this.props.error}
                </div>
            }

            <div className="row">
              <div className="col-xs-12 col-md-6">
                {/* Title */}
                <div className="form-group">
                  <label>Tittel</label>
                  <input type="text" className="form-control" name="title" defaultValue={warrantyPeriod.title} onChange={this.handleFieldChange} disabled={this.props.working || warrantyPeriod.archived} />
                </div>

                {/* Dates */}
                {!isMMC &&
                  <div className="form-group">
                    <label>Gjelder f.o.m. - t.o.m. <em className="small text-muted">(Påkrevet)</em></label>
                    <div className="row">
                      <div className="col-xs-6">
                        <DatePicker
                          name="startDate"
                          disabled={this.props.working || warrantyPeriod.archived}
                          className="form-control"
                          locale="nb"
                          dateFormat="dd.MM.yyyy"
                          selected={warrantyPeriod.fromDate}
                          onChange={(date) => date.setHours(0, 0, 0) && this.handleDateChange('fromDate', date)}
                          required
                        />
                      </div>
                      <div className="col-xs-6">
                        <DatePicker
                          name="expiryDate"
                          disabled={this.props.working || warrantyPeriod.archived}
                          className="form-control"
                          locale="nb"
                          dateFormat="dd.MM.yyyy"
                          selected={warrantyPeriod.toDate}
                          onChange={(date) => date.setHours(23, 59, 59) && this.handleDateChange('toDate', date)}
                          required
                        />
                      </div>
                    </div>
                  </div>
                }

                <div className="row">
                  {/* Valid for */}
                  <div className="col-xs-12 col-md-6">
                    <div className="form-group">
                      <label>Gjelder for</label>
                      <div className="checkbox">
                        <label>
                          <input type="checkbox" name="electric" defaultChecked={warrantyPeriod.electric} onChange={this.handleFieldChange} disabled={this.props.working || warrantyPeriod.archived} />
                          El-bil / hybrid
                        </label>
                      </div>
                      <div className="checkbox">
                        <label>
                          <input type="checkbox" name="van" defaultChecked={warrantyPeriod.van} onChange={this.handleFieldChange} disabled={this.props.working || warrantyPeriod.archived} />
                          Varebil
                        </label>
                      </div>
                    </div>
                  </div>

                  {/* Import type (MMC only) */}
                  {isMMC &&
                    <div className="col-xs-12 col-md-6">
                      <div className="form-group">
                        <label>Import type</label>
                        <div className="checkbox">
                          <label>
                            <input type="checkbox" name="mgImport" defaultChecked={warrantyPeriod.mgImport} onChange={this.handleFieldChange} disabled={this.props.working || warrantyPeriod.archived} />
                            MG import
                          </label>
                        </div>
                        <div className="checkbox">
                          <label>
                            <input type="checkbox" name="usedImport" defaultChecked={warrantyPeriod.usedImport} onChange={this.handleFieldChange} disabled={this.props.working || warrantyPeriod.archived} />
                            Bruktimport
                          </label>
                        </div>
                      </div>
                    </div>
                  }
                </div>

                {!isMMC &&
                  <div>
                    {/* Tekster */}
                    <div className="form-group">
                      <label>Standard/Utvidet garanti tekst</label>
                      <textarea
                        className="form-control"
                        name="standardWarrantyText"
                        rows="2"
                        defaultValue={warrantyPeriod.standardWarrantyText}
                        disabled={this.props.working || warrantyPeriod.archived}
                        onChange={this.handleFieldChange}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label>Lakkgaranti tekst</label>
                      <textarea
                        className="form-control"
                        name="paintWarrantyText"
                        rows="2"
                        defaultValue={warrantyPeriod.paintWarrantyText}
                        disabled={this.props.working || warrantyPeriod.archived}
                        onChange={this.handleFieldChange}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label>Rustgaranti tekst</label>
                      <textarea
                        className="form-control"
                        name="rustWarrantyText"
                        rows="2"
                        defaultValue={warrantyPeriod.rustWarrantyText}
                        disabled={this.props.working || warrantyPeriod.archived}
                        onChange={this.handleFieldChange}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label>Batterigaranti tekst</label>
                      <textarea
                        className="form-control"
                        name="batteryWarrantyText"
                        rows="2"
                        defaultValue={warrantyPeriod.batteryWarrantyText}
                        disabled={this.props.working || warrantyPeriod.archived}
                        onChange={this.handleFieldChange}
                      />
                    </div>
                  </div>
                }
              </div>

              <div className="col-xs-12 col-sm-6">
                <div className="form-group">
                  <label>Merke (kan ikke endres)</label>
                  <EntityField
                    name="make"
                    contentType="make"
                    value={warrantyPeriod.make}
                    onChange={this.handleAssetChange}
                    disabled={true}
                  />
                </div>

                {isMMC &&
                  <div className="form-group">
                    <label>Modell</label>
                    <EntityField
                      name="model"
                      contentType="model"
                      value={warrantyPeriod.model}
                      onChange={this.handleAssetChange}
                      disabled={this.props.working || warrantyPeriod.archived}
                      allowEdit={false}
                    />
                  </div>
                }

                <div className="form-group">
                  <label>Garantidokument</label>
                  <EntityField
                    name="warrantyDocument"
                    contentType="warranty"
                    value={warrantyPeriod.warrantyDocument}
                    onChange={this.handleAssetChange}
                    disabled={this.props.working || warrantyPeriod.archived}
                    searchOnOpen={true}
                    allowEdit={warrantyPeriod.warrantyDocument && `/warranties/${this.props.makeName}/${warrantyPeriod.warrantyDocument.id}`}
                  />
                </div>
              </div>
            </div>

            {isMMC &&
              <div className="row">
                <div className="col-xs-12">
                  <h2>Garantidata for MMC</h2>
                  <p className="alert alert-info">
                    Etter du har lagt inn data i en ny rad i en av tabellene, må du huske å trykke på den lilla &laquo;Lagre&raquo;-knappen til høyre for raden,
                    slik at ny data blir registrert.
                  </p>
                </div>

                <div className="mf-margin-top-10 mf-margin-bottom-20 col-xs-12">
                  <label>Nybil- og rustgarantier <span className="text-muted">(Gjelder registreringsår)</span></label>
                  <ArrayEditor
                    className="warrantyTable"
                    type={schemaReg}
                    object={warrantyPeriod.jsonReg}
                    onUpdateElement={(el, index) => this.updateRow(el, index, 'jsonReg')}
                    onAddElement={(e) => this.addRow(e, 'jsonReg')}
                    onRemoveElements={(e) => this.removeRows(e, 'jsonReg')}
                  />
                </div>

                <div className="mf-margin-top-20 mf-margin-bottom-20 col-xs-12">
                  <label>EV komponenter og driftsbatteri <span className="text-muted">(Gjelder årsmodell)</span></label>
                  <ArrayEditor
                    className="warrantyTable"
                    type={schemaBattery}
                    object={warrantyPeriod.jsonBattery}
                    onUpdateElement={(el, index) => this.updateRow(el, index, 'jsonBattery')}
                    onAddElement={(e) => this.addRow(e, 'jsonBattery')}
                    onRemoveElements={(e) => this.removeRows(e, 'jsonBattery')}
                  />
                </div>
              </div>
            }
          </form>
        </section>
      );
    }
  }
}

export default WarrantyPeriod;
